<ion-header>
  <ion-toolbar>
    <ion-title>Preguntas y Respuestas de esta misión</ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>

  <ion-card *ngFor="let response of missionAnswers">
    <div class="infoContainer backgroundColor{{response.state}}">{{response.spanish_state}}</div>
    <ion-list>
      <ion-item *ngFor="let answer of response.answers" lines="none">
        <ion-label>
          <h2 class="labels">{{answer.question}}:</h2>
          <p style="margin-left: 10px; white-space: break-spaces;" *ngIf="!answer.isUrl && !answer.isObject">
            {{answer.body}}</p>
          <img (click)="$event.stopPropagation();presentProductSlidesModal(answer.body)" class="billImage clickable"
            *ngIf="answer.isUrl && answer.isImage" [src]="answer.body" />
          <img (click)="$event.stopPropagation();openFileNewTab(answer.body)" class="billFile clickable"
            *ngIf="answer.isUrl && answer.isFile" src="/assets/icon/pdf.svg" />
          <p style="margin-left: 10px;white-space: break-spaces;line-height: 20px;height: 40px;"
            *ngIf="answer.isObject">
            {{answer.body}}</p>
        </ion-label>
      </ion-item>
    </ion-list>
    <p class="colorLight comment-response" *ngIf="response.response_comments != ''">
      <b>Comentario:</b> <span>{{response.response_comments}}</span>
    </p>
    <p class="colorLight date-response">
      #{{response.id}} - Fecha creación: <span>{{response.created | date: 'dd/MM/yyyy'}}</span>
    </p>

  </ion-card>

  <!--INFINITE SCROLL-->
  <ion-infinite-scroll threshold="100px" (ionInfinite)="loadUserAnswers($event)">
    <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Cargando más preguntas y respuestas...">
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>